export function toggleSnack() {
  return {
    type: '@snack/TOGGLE',
  };
}
